// src/api/apiClient.js
import axios from 'axios';

// 🛑 1. URL base de tu API PHP (Ajusta si es necesario) 🛑
const BASE_URL = 'https://trackingsv.neurals.pro/index.php/';

// Crea la instancia de Axios. ESTA ES TU VARIABLE 'apiClient'
const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 🛑 2. Interceptor de Seguridad: Inyecta el Token JWT 🛑
apiClient.interceptors.request.use(
    config => {
        // Asume que guardaste el token JWT después del login con la clave 'jwt_token'
        const token = localStorage.getItem('accessToken');

        if (token) {
            // Añade el header "Authorization: Bearer [tu_token]"
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default apiClient;